(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('organisational-units', {
            parent: 'account',
            url: '/organisational-units',
            data: {
                authorities: ['PERM_USER_ADMIN'],
                pageTitle: 'global.menu.account.organisational.units'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/organisational-units/organisational-units-list/organisational-units.html',
                    controller: 'OrganisationalUnitsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('users');
                    $translatePartialLoader.addPart('organisational.units');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
